//
//
//
//
//
//
//
//
//

export default {
  name: 'SfSelectOption',
  props: {
    value: {
      type: [String, Number, Object],
      default: '',
    },
  },
};
